export class LoyaltyProgramTypes {
    id: number;
    name: string;
    isValid: boolean;
}